class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Changed to target the .first-menu-item for click events
    const firstMenuItem = this.querySelector('.first-menu-item');
    if (firstMenuItem) {
      firstMenuItem.addEventListener('click', (event) => {
        // Ensure the toggle logic executes only when the first-menu-item is clicked
        // and not when its children (excluding summary or its children) are clicked
        if (!event.target.closest('summary')) {
          this.toggleOpen();
        }
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  toggleOpen() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle(); // Make sure any toggle-associated actions or animations are executed
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.curtain = document.querySelector('.mega-menu-curtain'); 
    this.stickyHeader = document.querySelector('sticky-header'); // Add this line


  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (this.mainDetailsToggle.open) {
      this.curtain.classList.add('curtain-open'); // Add curtain effect
      this.stickyHeader.classList.add('curtain-open'); // Add curtain effect
     this.stickyHeader.classList.add('is-blurred');
      this.lockScroll(); // Lock the background scroll

    } else {
      this.curtain.classList.remove('curtain-open'); // Remove curtain effect
      this.unlockScroll(); // Unlock the background scroll
      this.stickyHeader.classList.remove('is-blurred');

    }
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
  lockScroll() {
    // Use GSAP to smoothly lock scroll, or directly set the body's overflow style
    // Alternatively, for an immediate effect without animation:
    // document.body.style.overflow = 'hidden';
  }

  unlockScroll() {
    // Use GSAP to smoothly unlock scroll, or directly reset the body's overflow style
    // Alternatively, for an immediate effect without animation:
    // document.body.style.overflow = '';
  }

}

customElements.define('header-menu', HeaderMenu);

